// extracted by mini-css-extract-plugin
module.exports = {"btn":"LocaleSwitcher_btn__A6ynj"};